import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * 法務連結（私隱政策／刪除資料／服務條款）
 *
 * ⚠️ 位置：**卡片外面、貼螢幕最底**（產品負責人 2026-10-06 指定）—— 唔准放喺登入卡內。
 * ⚠️ `absoluteLinks`：理事會端（第 2 個 PWA）嘅 router 只有 `/committee/*`
 *    → 一定要用真 `<a>`（離開呢個 app），唔可以用 router `<Link>`。
 * ⚠️ `env(safe-area-inset-bottom)`：iPhone 底部橫條安全區。
 */
export default function LegalFooter({ absoluteLinks = false }: { absoluteLinks?: boolean }) {
  const { t } = useTranslation();
  const items = [
    { to: '/privacy', label: t('footer_privacy') },
    { to: '/data-deletion', label: t('footer_deletion') },
    { to: '/terms', label: t('footer_terms') },
  ];
  const style: React.CSSProperties = { color: 'var(--color-text-secondary)', textDecoration: 'none' };

  return (
    <footer
      className="flex flex-wrap justify-center gap-x-5 gap-y-1 text-xs px-4"
      style={{ marginTop: 'auto', paddingBottom: 'calc(16px + env(safe-area-inset-bottom))' }}
    >
      {items.map((it) =>
        absoluteLinks ? (
          <a key={it.to} href={it.to} style={style}>
            {it.label}
          </a>
        ) : (
          <Link key={it.to} to={it.to} style={style}>
            {it.label}
          </Link>
        ),
      )}
    </footer>
  );
}
